<template>
    <div class="parent-container">
        <div class="content-container">
            <div class="topic-sign-title">子课题管理</div>
            <div class="topic-sign-name">（{{topicInfo.topicName}}）</div>
            <div class="topic-status-container">
                <div :class="status===1?'status-item-container item-active':'status-item-container'" @click="changeStatus(1)">
                    <div class="status-time-container">
                        <div class="status-time1">报名阶段</div>
                        <div class="status-time2">{{ timestampDate2(topicInfo.applyBeginTime)}}&nbsp;-&nbsp;{{ timestampDate2(topicInfo.applyEndTime)}}</div>
                    </div>
                    <div :class="status===1?'status-fx-container item-active':'status-fx-container'">
                        ＞
                    </div>
                </div>

                <div :class="status===2?'status-item-container item-active':'status-item-container'" @click="changeStatus(2)">
                    <div class="status-time-container">
                        <div class="status-time1">开题阶段</div>
                        <div class="status-time2">{{ timestampDate2(topicInfo.ktBeginTime)}}&nbsp;-&nbsp;{{ timestampDate2(topicInfo.ktEndTime)}}</div>
                    </div>
                    <div :class="status===2?'status-fx-container item-active':'status-fx-container'">
                        ＞
                    </div>
                </div>

                <div :class="status===3?'status-item-container item-active':'status-item-container'" @click="changeStatus(3)">
                    <div class="status-time-container">
                        <div class="status-time1">中期检查</div>
                        <div class="status-time2">{{ timestampDate2(topicInfo.beginTime)}}&nbsp;-&nbsp;{{ timestampDate2(topicInfo.endTime)}}</div>
                    </div>
                    <div :class="status===3?'status-fx-container item-active':'status-fx-container'">
                        ＞
                    </div>
                </div>

                <div :class="status===4?'status-item-container item-active':'status-item-container'" @click="changeStatus(4)">
                    <div class="status-time-container">
                        <div class="status-time1">结题验收</div>
                        <div class="status-time2">{{ timestampDate2(topicInfo.jtBeginTime)}}&nbsp;-&nbsp;{{ timestampDate2(topicInfo.jtEndTime)}}</div>
                    </div>
                    <div class="status-fx-container">
                    </div>
                </div>
            </div>
            <div class="list-title-container">
                <div class="list1">报名列表</div>
                <div v-if="status===1" class="status-info-bm">报名阶段</div>
                <div v-if="status===2" class="status-info-kt">开题阶段</div>
                <div v-if="status===3" class="status-info-zq">中期检查</div>
                <div v-if="status===4" class="status-info-jt">结题验收</div>
            </div>
            <!--报名列表-->
            <div class="bre9e mt5">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 310px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                    <el-table-column align="center" label="报名时间" width="130" prop="">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.createTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="教师姓名" width="80" prop="trueName"/>
                    <el-table-column width="95" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="80" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <!-- 申报阶段 -->
                    <el-table-column v-if="status===1" width="80" fixed="right" align="center" label="审核专家" prop="sbCheckUserName">
                    </el-table-column>
                    <el-table-column v-if="status===1" width="80" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.sbStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.sbStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.sbStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.sbStatus===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>
                    <!-- 开题阶段 -->
                    <el-table-column v-if="status===2" width="80" fixed="right" align="center" label="审核专家" prop="ktCheckUserName">
                    </el-table-column>
                    <el-table-column v-if="status===2" width="80" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.ktStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.ktStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.ktStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.ktStatus===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>
                    <!-- 中期检查 -->
                    <el-table-column v-if="status===3" width="80" fixed="right" align="center" label="审核专家" prop="zqCheckUserName">
                    </el-table-column>
                    <el-table-column v-if="status===3" width="80" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.zqStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.zqStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.zqStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.zqStatus===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>
                    <!-- 结题验收 -->
                    <el-table-column v-if="status===4" width="80" fixed="right" align="center" label="审核专家" prop="jtCheckUserName">
                    </el-table-column>
                    <el-table-column v-if="status===4" width="80" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.jtStatus===1" class="tab-dfp">待分配</div>
                            <div v-if="scope.row.jtStatus===2" class="tab-dsh">待审核</div>
                            <div v-if="scope.row.jtStatus===3" class="tab-shtg">通过</div>
                            <div v-if="scope.row.jtStatus===4" class="tab-shjj">拒绝</div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" width="100" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="120" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-if="(scope.row.sbStatus===1||scope.row.ktStatus===1||scope.row.jtStatus===1||scope.row.zqStatus===1)&&(this.role==1||this.role==2||this.userId==this.parentTopicInfo.leader||(this.parentTopicInfo.checkUsers&&this.parentTopicInfo.checkUsers.includes(this.userId)))">
                                            <el-text type="primary" @click="topicFp(scope.row)">分配</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" v-if="status===1" @click="bmView(scope.row)" >查看</el-text>
                                            <el-text type="primary" v-if="status===2" @click="ktView(scope.row)">查看</el-text>
                                            <el-text type="primary" v-if="status===3" @click="zqView(scope.row)">查看</el-text>
                                            <el-text type="primary" v-if="status===4" @click="jtView(scope.row)">查看</el-text>
                                        </div>
                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getPageTopicSign" />
            </div>
        </div>

        <el-dialog  v-model="isFpShow" width="640px" :show-close="false">
            <div class="topic-fp-title">审核分配</div>
            <el-card class="fp-container" :body-style="{padding: '10px 10px 10px 10px'}">
                <div class="check-top-container">
                    <div class="refresh-container" >
                        <div class="refresh-icon" @click="refreshCheckUser">
                            <img class="img-100" src="../../assets/refresh.png" alt="">
                        </div>
                        <div class="refresh-title" @click="refreshCheckUser">刷新列表</div>
                    </div>
                    <div class="search-container">
                        <el-input v-model="checkUserName" class="w-50 m-2"
                                  placeholder="按姓名搜索专家" :prefix-icon="Search"/>
                    </div>
                </div>
                <el-scrollbar class="fp-scrollbar" >
                    <div v-for="item in filterCheckUser" class="check-user-item">
                        <div class="sel-container" @click="selCheckUser(item.userId)">
                            <div class="check-icon-container">
                                <img class="img-100" v-if="checkUserId!==item.userId" src="../../assets/img/uncheck.png" alt="">
                                <img class="img-100" v-if="checkUserId===item.userId" src="../../assets/img/checked.png" alt="">
                            </div>
                            <div class="check-icon-word">
                                分配
                            </div>
                        </div>
                        <div class="sel-user-container">
                            <div class="user-check-data">
                                <div class="data-user">{{item.trueName}}</div>
                                <div class="data-item">已分配：{{item.fpCount}}</div>
                                <div class="data-item">已评估：{{item.shCount}}</div>
                            </div>
                            <div class="user-check-pro">
                                <el-progress :percentage="item.rateCount" />
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </el-card>

            <div class="fp-btn-container">
                <el-button type="primary" style="margin: auto" @click="submitCheckInfo">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { serviceUrl } from "@/utils/global"
import {checkUserSignList, infoTopic} from "@/api/admin/topic"
import {leadInfo} from "@/api/admin/lead"
import { pageTopicSign,divideCheckUser } from "@/api/admin/topicSign"
import {timestampToTime,timestampDate2} from "@/utils/date";
import {Search} from "@element-plus/icons";
export default {
    name: "subTopicManager",
    components: {},
    data() {
        return {
            token: this.$storage.get("token"),
            role:this.$storage.get("role") ,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            serviceUrl,
            timestampToTime,
            timestampDate2,
            topicId:'',
            parentTopicId:'',
            topicInfo:{},
            parentTopicInfo:{},
            activeModel:'1',
            isFpShow:false,
            checkUserId:"",
            checkUserName:'',
            checkUserList:[],
            status:0,
            total: 0,
            pageCount:0,
            dataList: [],
            queryParams: {
                topicDirection: '',
                status: '',
                pageNum: 1,
                pageSize: 10,
            },
            queryCheckUserForm:{
                topicId:'',
                status:'',
            },
            checkForm:{
                signId:'',
                userId:'',
                status:'',
            }
        };
    },
    created() {},
    mounted() {
        if (this.$route.query.topicId) {
            this.topicId = this.$route.query.topicId
            this.getTopicInfo()
        }
    },
    unmounted() {},
    computed: {
        Search() {
            return Search
        },
        filterCheckUser(){
            if (this.checkUserName=== ''){
                return this.checkUserList;
            }
            return this.checkUserList.filter((item)=>{
                return item.trueName.includes(this.checkUserName)
            })
        }
    },
    methods: {
        getTopicInfo() {
            leadInfo({ topicId: this.topicId }).then(res => {
                if (res.data.code === 1) {
                    this.topicInfo = res.data.data;
                    this.status = this.topicInfo.status;
                    this.queryParams.status = this.topicInfo.status;
                    this.queryParams.topicDirection = this.topicInfo.topicId;
                    this.parentTopicId = this.topicInfo.parentTopicId
                    this.getPageTopicSign()
                    this.getParTopicInfo()
                    this.queryCheckUserForm.topicId = this.topicId;
                    this.queryCheckUserForm.status = this.topicInfo.status
                    checkUserSignList(this.queryCheckUserForm).then(res => {
                        if (res.data.code === 1) {
                            this.checkUserList = res.data.data;
                        }
                    })
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        getParTopicInfo() {
            infoTopic({ topicId: this.parentTopicId }).then(res => {
                  if (res.data.code === 1) {
                      this.parentTopicInfo = res.data.data;
                  }else {
                      this.$message.error("请求出错")
                  }

            })
        },
        getPageTopicSign(e){
            this.dataList = []
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageTopicSign(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.dataList = res.data.data.list;
                    this.total = res.data.data.total;
                    this.pageCount = res.data.data.totalPage;
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        topicFp(row){
            this.checkForm.signId = row.signId;
            this.checkUserId = ""
            this.checkForm.userId = ""
            // if (row.checkUser){
            //     this.checkUserId = row.checkUser
            //     this.checkForm.userId = row.checkUser
            // }
            this.isFpShow = true;
        },
        refreshCheckUser(){
            checkUserSignList(this.queryCheckUserForm).then(res => {
                if (res.data.code === 1) {
                    this.checkUserList = res.data.data;
                    this.$message.success("刷新成功")
                }else {
                    this.$message.error("请求出错")
                }

            })
        },
        selCheckUser(userId){
            this.checkUserId = userId;
            this.checkForm.userId = userId;
        },
        submitCheckInfo(){
            if(this.checkForm.userId===''||
              this.checkForm.userId===null
                || this.checkForm.userId===undefined){
                this.$message.error("请选择审核人")

                return;
            }
            this.checkForm.status = this.status;
            divideCheckUser(this.checkForm).then(res => {
                if (res.data.code === 1) {
                    this.isFpShow = false;
                    this.getPageTopicSign()
                }else{
                    this.$message.error("请求出错")
                }
            })
        },
        bmView(row){
            this.$router.push({
                path: "/topicBmCheck",
                query: {
                    signId: row.signId,
                }
            });
        },
        ktView(row){
            this.$router.push({
                path: "/topicKtCheck",
                query: {
                    signId: row.signId,
                }
            });
        },
        zqView(row){
            this.$router.push({
                path: "/topicZqCheck",
                query: {
                    signId: row.signId,
                }
            });
        },
        jtView(row){
            this.$router.push({
                path: "/topicJtCheck",
                query: {
                    signId: row.signId,
                }
            });
        },
        changeStatus(status){
            this.status = status;
            this.queryParams.status = status;
            if (status>this.topicInfo.status){
                this.$message.info("暂未进行到该阶段")
                return;
            }
            this.getPageTopicSign()
        }
    }
};
</script>
<style scoped>
.parent-container{
    height: 100%;
    width: 100%;
    padding: 10px 10px 20px 20px;
    box-sizing: border-box;
}
.content-container{
    height: 100%;
    width: 100%;
    background-color: #fff;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.topic-sign-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #0d55a4;
    margin-top: 5px;
    text-align: center;
}
.topic-sign-name{
    width: 100%;
    height: 30px;
    font-size: 15px;
    color: #333333;
    text-align: center;
}
.topic-status-container{
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #0d55a4;
    display: flex;
}
.item-active{
    color: #0d55a4!important;
}
.status-item-container{
    width: 240px;
    height: 100%;
    display: flex;
    cursor: pointer;
}
.status-time-container{
    width: 220px;
    height: 100%;
}
.status-time1{
    width: 100%;
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
}
.status-time2{
    width: 100%;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    font-weight: bold;
    text-align: center;
}
.status-fx-container{
    width: 20px;
    height: 100%;
    line-height: 60px;
    text-align: center;
    font-weight: bold;
    color: #989898;
}
.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}
.check-top-container{
    width: 100%;
    height: 40px;
    border-bottom: 2px solid #ccc;
    display: flex;
}
.refresh-container{
    width: 60%;
    height: 40px;
    display: flex;
    cursor: pointer;
}
.refresh-icon{
    width: 22px;
    height: 22px;
    margin-top: 9px;
    margin-left: 20px;
}
.refresh-title{
    width: auto;
    height: 30px;
    line-height: 30px;
    color: #000000;
    margin-top: 5px;
}
.search-container{
    width: 40%;
    height: 26px;
}
/deep/ .el-dialog__header{
    padding-bottom: 0!important;
}
.topic-fp-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    font-weight: bold;
    color: #0d55a4;
    text-align: center;
}
.fp-container{
    width: 90%;
    height: 400px;
    margin: auto;
    border-radius: 10px;
}
.fp-btn-container{
    padding-top: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
}
.fp-scrollbar{
    width: 100%;
    height: 400px;
    margin-top: 6px;
}
.check-user-item{
    width: 100%;
    height: 70px;
    display: flex;
}
.sel-container{
    width: 80px;
    height: 70px;
    display: flex;
    padding-left: 20px;
    box-sizing: border-box;
    cursor: pointer;
}
.check-icon-container{
    width: 18px;
    height: 18px;
    margin-top: 26px;
}
.check-icon-word{
    height: 70px;
    line-height: 70px;
}
.sel-user-container{
    width: calc(100% - 100px);
    height: 60px;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-top: 4px;
    padding:0 10px 0 10px;
    box-sizing: border-box;
}
.user-check-data{
    width: 100%;
    height: 35px;
    display: flex;
    padding-top: 5px;
    box-sizing: border-box;
}
.data-user{
    width: calc(100% - 160px);
    height: 35px;
    padding-top: 5px;
    box-sizing: border-box;
    color: #333333;
    font-weight: bold;
    font-size: 14px;
}
.data-item{
    width: 80px;
    height: 35px;
    padding-top: 5px;
    box-sizing: border-box;
    color: #999999;
    text-align: right;
}
.user-check-pro{
    width: 100%;
    height: 20px;
}

.list-title-container{
    width: 100%;
    height: 20px;
    border-left: 5px solid #0d55a4;
    margin-top: 5px;
    margin-bottom: 5px;
    display: flex;
}
.list1{
    width: auto;
    height: 20px;
    line-height: 20px;
    text-indent: 5px;
    font-size: 15px;
    font-weight: bold;
    margin-right: 10px;
}
.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
</style>